import {
  Box,
  Divider,
  Grid2,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { api_Routes } from "../../api_Routes";
import { Helper } from "../../tools/Helper";

const Terms = () => {
  const [Page, setPage] = useState({});
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const getPage = async () => {
      setIsLoading(true);
      const url = `${api_Routes.Pages.View}/terms`;
      const { response } = await Helper.Get({
        url,
        hasToken: true,
      });
      if (response) {
        setPage(response);
        setSections(response.sections);
      }
      setIsLoading(false);
    };
    getPage();
  }, []);
  if (isLoading) return <LinearProgress />;
  return (
    <>
      <Typography
        sx={{
          fontWeight: "700",
          fontSize: "50px",
          lineHeight: "75px",
          color: "#474747",
          textAlign: "center",
        }}
      >
        Term of use
      </Typography>

      <Box
        sx={{
          background: "#E5EDFF",
          padding: "30px",
          borderRadius: "25px",
          marginTop: "20px",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 item xs={12} sm={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Box>
                <Typography
                  sx={{
                    fontSize: "30px",
                    fontWeight: "600",
                    marginBottom: "20px",
                    color: "#474747",
                    lineHeight: "35px",
                  }}
                >
                  Introduction
                </Typography>
              </Box>
              <Typography>{sections[0]?.content?.body}</Typography>
            </Box>
          </Grid2>

          <List sx={{ width: "100%" }}>
            {sections[0]?.features?.map((fe, index) => (
              <>
                <ListItem alignItems="flex-start" sx={{ py: 2 }}>
                  <ListItemText
                    primary={
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{ fontWeight: "bold" }}
                      >
                        {fe.title}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        component="span"
                        variant="body1"
                        sx={{ display: "inline" }}
                      >
                        {fe.description}
                      </Typography>
                    }
                  />
                </ListItem>

                <Divider component="li" />
              </>
            ))}
          </List>
        </Grid2>
      </Box>
    </>
  );
};

export default Terms;
